// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__31Wdi","actions":"GroupTable_actions__3yrnB","deleteModalFooter":"GroupTable_deleteModalFooter__3SCv9"};